/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumber } from '../../models/access-number';

export interface GetAccessnumberId$Json$Params {
  id: string;
  'api-version'?: string;
}

export function getAccessnumberId$Json(http: HttpClient, rootUrl: string, params: GetAccessnumberId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumber>> {
  const rb = new RequestBuilder(rootUrl, getAccessnumberId$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccessNumber>;
    })
  );
}

getAccessnumberId$Json.PATH = '/accessnumber/{id}';
